import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useWindowSize } from 'usehooks-ts';

import useLog from '../hooks/useLog.js';
import { Slide } from "../display_wallet.js"
import { getLog } from '../helpers/helpers.js';
import SoldeBSV from '../components/SoldeBSV.js';
import SoldeToken from '../components/SoldeToken.js';
import GlowingHoverDiv from '../components/GlowingHoverDiv.js';
import Hint from '../components/Hint.js';
import WaitlistButton from '../components/WaitlistButton.js';
import LoginLogoutButton from '../components/LoginLogoutButton.js';
import Constants from '../config.js';
import { ALLOWED_COINS, UserContext } from '../Contexts/UserContext/UserContext.js';


/**
 * props:
 * 		- num - slide number
 */
const Slide_WalletHome = (props) => {
	const function_id = "Slide_WalletHome: "
	const log = useLog(function_id)

	const history = useHistory()
	const userContext = useContext(UserContext)
	const { width: windowWidth = 0 } = useWindowSize()
	const isMobile = windowWidth < Constants.WINDOW_WIDTH_THRESHOLD_PX

	const walletname = userContext.walletname
	const title = walletname ? walletname + "'s Wallet" : "My Wallet"

	const onClickTokenCard = (new_selected_coin) => {
		const function_id_2 = function_id + "onClickTokenCard(new_selected_coin=" + new_selected_coin + "): "
		let log_2 = getLog(function_id_2)
		log_2()

		// The `:token_id` path param is the source of truth; useTokenOrigin()
		// keeps UserContext.selected_coin in sync with it.
		history.push(`/wallet/${new_selected_coin}`)
	}

	const onTokenKeyDown = (e, coin) => {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault()
			onClickTokenCard(coin)
		}
	}

	const tokens = Object.values(ALLOWED_COINS).map(coin => ({
		tokenid: coin.tokenid,
		label: coin.name,
		render: () => coin.class_origin != null
			? <SoldeToken row tokenid={coin.tokenid} />
			: <SoldeBSV row />,
	}))

	return (
		<Slide num={props.num}>

			<div style={{ textAlign: "center", marginBottom: "2em" }}>
				<h1 style={{ marginTop: "0", fontSize: "2em" }}>
					{title}
				</h1>
			</div>

			{userContext.isMockWallet === true ? (
				<WaitlistButton variant="full" />
			) : null}

			<Hint style={{ marginBottom: "1.5em" }}>
				Click on a token to select it
			</Hint>

			<div style={{ display: "flex", flexDirection: "column", gap: "1em" }}>
				{tokens.map(({ tokenid, label, render }) => (
					<GlowingHoverDiv
						key={tokenid}
						role="button"
						tabIndex={0}
						aria-label={"Select " + label + " token"}
						onClick={() => onClickTokenCard(tokenid)}
						onKeyDown={(e) => onTokenKeyDown(e, tokenid)}
						style={{ cursor: 'pointer' }}
					>
						{render()}
					</GlowingHoverDiv>
				))}
			</div>

			{/* Mobile-only: quick Settings access + Logout, so the user
				doesn't need to open the full menu for these common actions. */}
			{isMobile ? (
				<div className="mobileHomeQuickActions">
					<button
						type="button"
						className="mobileHomeSettingsButton"
						onClick={() => history.push('/wallet/settings')}
					>
						<i className="fas fa-cog" /> &nbsp; Settings
					</button>
					<div className="mobileHomeLogoutRow">
						<LoginLogoutButton className="menuLogoutRowInner" withIcon />
					</div>
				</div>
			) : null}

		</Slide>
	)
}

export default Slide_WalletHome
